module.exports = __webpack_public_path__ + "public/images/escape-rooms.00d6a0a73a8648e49bf63f4e6db548f3.jpg";